/**
 * Architects & Engineers - All Projects Page
 * Architecture and engineering projects management
 */

import { useEffect } from 'react';
import { AllProjectsPage } from '@/components/industry/pages/AllProjectsPage';
import { CompanyType } from '@/types/company';
import { MainLayout } from "@/components/MainLayout";

export default function ArchitectsEngineersProjectsPage() {
  useEffect(() => {
    document.title = 'Todos os Projetos | Controle Financeiro';
  }, []);

  return (
<MainLayout>
    <div className="container mx-auto py-6">
      <AllProjectsPage
        domain={CompanyType.ARCHITECTS_ENGINEERS}
        title="Todos os Projetos"
        description="Gerencie seus projetos de arquitetura e engenharia"
        createButtonLabel="Novo Projeto"
      />
    </div>
  
    </MainLayout>);
}

